import styled, { css } from 'styled-components';
import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const primaryStyles = css `
  background-color: ${theme.swatches.warm[100]};
  border-color: ${theme.swatches.warm[300]};
  color: ${theme.semantic.foreground.primary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
const secondaryStyles = css `
  background-color: ${theme.semantic.surface.sunken};
  border-color: ${theme.semantic.border.default};
  color: ${theme.semantic.foreground.secondary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
const infoStyles = css `
  background-color: ${theme.swatches.blue[100]};
  border-color: ${theme.swatches.blue[300]};
  color: ${theme.swatches.blue[900]};

  [data-icon='falcon'] {
    color: ${theme.swatches.blue[900]};
  }
`;
const successStyles = css `
  background-color: ${theme.swatches.green[100]};
  border-color: ${theme.swatches.green[300]};
  color: ${theme.swatches.green[900]};

  [data-icon='falcon'] {
    color: ${theme.swatches.green[900]};
  }
`;
const dangerStyles = css `
  background-color: ${theme.swatches.red[100]};
  border-color: ${theme.swatches.red[300]};
  color: ${theme.swatches.red[900]};

  [data-icon='falcon'] {
    color: ${theme.swatches.red[900]};
  }
`;
const warningStyles = css `
  background-color: ${theme.swatches.yellow[100]};
  border-color: ${theme.swatches.yellow[400]};
  color: ${theme.semantic.foreground.secondary};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }
`;
const stylesFromAppearance = (props) => {
    switch (props.appearance) {
        case 'primary':
            return primaryStyles;
        case 'info':
            return infoStyles;
        case 'success':
            return successStyles;
        case 'danger':
            return dangerStyles;
        case 'warning':
            return warningStyles;
        case 'secondary':
        default:
            return secondaryStyles;
    }
};
export const Banner = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => !['appearance'].includes(prop),
})
    .attrs((p) => (Object.assign({ gap: 'md', alignItems: 'center', justifyContent: 'center', px: 'lg', py: 'md', role: 'alert' }, p))) `
  font-size: ${theme.fontSize.small};
  text-align: center;

  border-radius: ${theme.borderRadius.md};
  border: ${pxToRem(1)} solid transparent;

  line-height: ${theme.lineHeight.neutralized};

  ${Typography} {
    font-size: ${theme.fontSize.small};
    font-weight: ${theme.fontWeight.medium};
  }

  ${stylesFromAppearance};
`;
